<template>
  <div
    class="forbidden">
    <span class="wrapper flex center-all">
      <span class="emoji">😐</span>
      <p>You don’t have a permission to do this action.</p>
    </span>
    <span class="refresh-me flex center-all">
      <!-- Please <a href=".">refresh page</a>.-->
      Please contact your admin to enable<br>this for you.
    </span>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
};
</script>

<style lang="scss" scoped>
.forbidden {
  padding-top: 75px;

  .wrapper {
    margin: 0 auto;
    background-color: #f2f5f7;
    width: fit-content;
    padding: 10px 18px 10px 12px;
    border-radius: 50px;
    cursor: default;
    text-align: center;
    color: $blackLight;

    .emoji {
      font-size: 16px;
      margin-right: 8px;
    }

    p {
      font-size: 14px;
    }

    strong {
      font-weight: 500;
    }
  }

  .refresh-me {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: $blackUltralight;
    text-align: center;
    line-height: 1.4;

    a {
      margin-left: 4px;
      color: $blackLight !important;
      text-decoration: underline;
    }
  }
}
</style>
